import {PromotedSponsorshipModuleFetchHandler} from "./promoted-sponsorship-module.fetch-handler";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {PromotedSponsorshipModuleClickHandler} from "./promoted-sponsorship-module.click-handler";
import {PromotedSponsorshipModuleShowEventHandler} from "./promoted-sponsorship-module.show-event-handler";

export class PromotedSponsorshipModuleHandlers extends HandlerList {

  static injectables = [
    PromotedSponsorshipModuleFetchHandler,
    PromotedSponsorshipModuleClickHandler,
    PromotedSponsorshipModuleShowEventHandler,
    TimingHandler,
    PopulateDataHandler
  ];

  constructor(
    promotedSponsorshipModuleFetchHandler: PromotedSponsorshipModuleFetchHandler,
    promotedSponsorshipModuleClickHandler: PromotedSponsorshipModuleClickHandler,
    promotedSponsorshipModuleShowEventHandler: PromotedSponsorshipModuleShowEventHandler,
    timingHandler: TimingHandler,
    populateDataHandler: PopulateDataHandler
  ) {
    super();

    [
      promotedSponsorshipModuleFetchHandler,
      promotedSponsorshipModuleClickHandler,
      promotedSponsorshipModuleShowEventHandler,
      timingHandler,
      populateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
